import React, { Component } from 'react';
import PortalCompanyPermission from './portal-company-permission';
import JobFullDetailsJobNotificationsDetails from '../jobs/job-full-details/job-full-details-job-notifications-details';
export default class PortalAccountFullDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.initialValue || 'placeholder',
      appraisal_data: '',
      expenses_data: '',
      expense_approval_data: {},
      account_notifications_data: '',
      isLoadingAppraisalInfo: true,
      isLoadingExpensesInfo: true,
      isLoadingInvoiceInfo: true,
      driverPriceOption:(this.props.data.driver_id != null && this.props.data.driver && this.props.data.driver.driver_price_option) ? this.props.data.driver.driver_price_option : '' || '',
      isOtherDriverPrice:false,
      userCloneCount : 0
    };

    let that = this;
    Echo.channel('notifications-for-account-'+this.props.data.id)
      .listen('NewAccountNotification', (e) => {
        that.getAccountNotifications();
      });
    this.getAccountNotifications();
    this.changePortalAccountEmailAddress = this.changePortalAccountEmailAddress.bind(this);
    this.changePortalAccountDriverFuelCardNumber = this.changePortalAccountDriverFuelCardNumber.bind(this);
  }
  changePortalAccountStaffEmailAddress(){
    var userList =  new Array();
    let eleEmail = document.getElementsByClassName("staffListEmail");
    let elePassword = document.getElementsByClassName("staffListPassword");
    for(var i = 0; i < eleEmail.length; i++)
    {
      userList.push({'id': eleEmail[i].getAttribute('dataid') , 'email' : eleEmail[i].value, 'password' : elePassword[i].value});
    }
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-staff-list-email-password/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        userList: userList
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
      document.getElementById('infomodallabel').
      innerHTML = 'Staff List modified successfully';
      $('#infomodal .modal-body').html(
        $.parseHTML(
          data.
            replace(/\"/g, "")
        ));
      $('#infomodal').modal();
    });
  }
  addNewPortalUser(){
    let cloneCount = this.state.userCloneCount;
    cloneCount = (cloneCount+1);
    if(cloneCount>0)
    {
      $('.removePortalUserClone').removeClass('d-none');
      $('.savePortalUserClone').removeClass('d-none');
    }
    else {
      $('.removePortalUserClone').addClass('d-none');
      $('.savePortalUserClone').addClass('d-none');
    }
    if(cloneCount<=10)
    {
      var customer_options = '';
      if(this.props.data.customer_id != null){
        customer_options = '<div class="m-2"><label class="radio-inline mr-2"><input type="radio" name="user_type_list['+cloneCount+'][]" value="api_user"> Api User </label><label class="radio-inline mr-2"><input type="radio" name="user_type_list['+cloneCount+'][]" value="driver"> Companies Driver(Bot) </label><label class="radio-inline mr-2"><input type="radio" name="user_type_list['+cloneCount+'][]" value="staff" checked> Staff </label></div>';
      }
      var html='<div class="card sectionEmailPassword userList"><div class="card-body"><div class="input-group m-2"><input type="text" name="email_list[]" class="form-control newPortalEmail" placeholder="Enter Email Here" /></div><div class="input-group m-2"><input type="text" class="form-control newPortalPassword" name="password_list[]" placeholder="Enter Password Here" /></div>' + customer_options + '<div><div>';
      $('.sectionMultipleUsers').append(html);
      this.setState({userCloneCount : cloneCount});
    }
  }

  removePortalUser(){
    let cloneCount = this.state.userCloneCount;
    
    cloneCount = (cloneCount-1);
    $('.sectionEmailPassword:last').remove();
    if(cloneCount==0)
    {
      $('.removePortalUserClone').addClass('d-none');
      $('.savePortalUserClone').addClass('d-none');
    }
    this.setState({userCloneCount : cloneCount});
  }

  saveMultiplePortalUsers(){
    var userList =  new Array();
    let eleEmail = document.getElementsByClassName("newPortalEmail");
    let elePass = document.getElementsByClassName("newPortalPassword");
    let eleUserType = 'staff';
    for(var i = 0, j = 1; i < eleEmail.length; i++,j++ )
    {
      if(document.querySelector('input[name="user_type_list['+j+'][]"]:checked')) {
        eleUserType = document.querySelector('input[name="user_type_list['+j+'][]"]:checked').value;
      }
      userList.push({'email' : eleEmail[i].value, 'password' : elePass[i].value, 'user_type': eleUserType});
    }
    $.ajax({
      url: "/api/v1/portal/portal-admin/save-user-accounts/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        company_id : this.props.data.company_id,
        customer_id : this.props.data.customer_id,
        userList : userList
      },
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        console.log(data); 
        if(typeof data === 'object'){
          data = data.message;
        }
        document.getElementById('infomodallabel').
            innerHTML = 'New Portal User Accounts Created';
        $('#infomodal .modal-body').html(
          $.parseHTML(
            data.
              replace(/\"/g, "")
          ));
        $('#infomodal').modal();
      }).fail(function(jqXHR, textStatus, errorThrown){
        console.log(jqXHR.responseJSON)
        document.getElementById('infomodallabel').innerHTML = 'Error! Portal Account Creation';
        $('#infomodal .modal-body').html(
          $.parseHTML(
            errorThrown.
              replace(/\"/g, "")
          ));
        $('#infomodal').modal();
      });
  }

  getAccountNotifications() {
    let url = '/api/v1/portal/portal-admin/notifications/'+this.props.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((accountNotificationsJson) => {
        this.setState({
          account_notifications_data: accountNotificationsJson,
          isLoading: false
        })
      });
    });
  }

  setPortalAccountOnHoliday() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/set-account-on-holiday/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',

    })
      .done(function(data) {
        //  alert('aborted');
      });
  }

  setPortalAccountNotOnHoliday() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/set-account-not-on-holiday/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }

  lockPortalAccount() {
  let driverId = this.props.data.id;
    $.ajax({
      url: "/api/v1/portal/portal-admin/lock-account/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',

    })
      .done(function(data) {
          $('#infomodallabel').html('Success');
          $('#infomodal .modal-body').html(data);
          $('#infomodal').modal();
          $('#portal-admin-table-row-'+driverId).find('.column-type-account-status-active').html('locked');
        $('#portal-admin-table-row-'+driverId).find('.column-type-account-status-active').css('background', 'red');
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }

    unlockPortalAccount() {
    let driverId = this.props.data.id;
    $.ajax({
      url: "/api/v1/portal/portal-admin/unlock-account/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html(data);
        $('#infomodal').modal();
        $('#portal-admin-table-row-'+driverId).find('.column-type-account-status-locked').html('active');
        $('#portal-admin-table-row-'+driverId).find('.column-type-account-status-locked').css('background', 'green');
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }
  handleChecked(e){
    let isChecked = e.target.checked;
    $.ajax({
      url: "/api/v1/portal/portal-admin/mark-driver-archieved/"+this.props.data.id,
      data: {api_token: window.api_token,is_driver_archieved:(isChecked) ? 1 : 0},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Saved successfully');
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }
  handleCheckedcustomer(e){
    let isChecked = e.target.checked;
    $.ajax({
      url: "/api/v1/portal/portal-admin/mark-customer-archieved/"+this.props.data.id,
      data: {api_token: window.api_token,is_customer_archived:(isChecked) ? 1 : 0},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Saved successfully');
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }
  handleSickChecked(e){
    let isChecked = e.target.checked;
    $.ajax({
      url: "/api/v1/portal/portal-admin/mark-driver-as-sick/"+this.props.data.id,
      data: {api_token: window.api_token,is_driver_sick:(isChecked) ? 1 : 0},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Saved changes successfully');
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }

  handleDriverIsSmoker(e){
    let is_driver_smoker_val = e.target.value;
    $.ajax({
      url: "/api/v1/portal/portal-admin/mark-driver-as-smoker/"+this.props.data.id,
      data: {api_token: window.api_token,is_driver_smoker:is_driver_smoker_val},
      cache: false,
      method: 'post',
    }).done(function(data) {
        $('#is-driver-smoker-yes').removeClass('focus active');
        $('#is-driver-smoker-no').removeClass('focus active');
        if(is_driver_smoker_val == "1"){
          $('#is-driver-smoker-yes').addClass('focus active');
        }else{
          $('#is-driver-smoker-no').addClass('focus active');
        }
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Saved changes successfully..');
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }

  handleDriverIsGetPaidExpenses(e){
    let is_driver_get_paid_expenses_val = e.target.value;
    $.ajax({
      url: "/api/v1/portal/portal-admin/set-driver-as-get-paid-expenses/"+this.props.data.id,
      data: {api_token: window.api_token,is_driver_get_paid_expenses:is_driver_get_paid_expenses_val},
      cache: false,
      method: 'post',
    }).done(function(data) {
        $('#is-driver-get-paid-expenses-yes').removeClass('focus active');
        $('#is-driver-get-paid-expenses-no').removeClass('focus active');
        if(is_driver_get_paid_expenses_val == "1"){
          $('#is-driver-get-paid-expenses-yes').addClass('focus active');
        }else{
          $('#is-driver-get-paid-expenses-no').addClass('focus active');
        }
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Saved changes successfully..');
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }

  changePortalAccountPassword() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-password/"+this.props.data.id,
      data: {api_token: window.api_token,
        new_password: $('#portal-account-full-details-'+this.props.data.id+' input[name=new_password]').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }

  changePortalAccountName() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-name/"+this.props.data.id,
      data: {api_token: window.api_token,
        first_name: $('#portal-account-full-details-'+this.props.data.id+' input[name=first_name]').val(),
        last_name: $('#portal-account-full-details-'+this.props.data.id+' input[name=last_name]').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }

  changePortalAccountEmailAddress() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-email-address/"+this.props.data.id,
      data: {api_token: window.api_token,
        new_email: $('#portal-account-full-details-'+this.props.data.id+' input[name=new_email]').val()},
      cache: false,
      method: 'post',
    })
    .done(function(data) {
        //  alert('unaborted');
    });
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-password/"+this.props.data.id,
      data: {api_token: window.api_token,
      new_password: $('#portal-account-full-details-'+this.props.data.id+' input[name=new_password]').val()},
      cache: false,
      method: 'post',
    })
    .done(function(data) {
      //  alert('unaborted');
    });
  }

  changePortalAccountUTRNumber() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-utr-number/"+this.props.data.id,
      data: {api_token: window.api_token,
        utr_number: $('#portal-account-full-details-'+this.props.data.id+' input[name=utr_number]').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html(data);
        $('#infomodal').modal();
      });

  }

  changePortalAccountRoles() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-roles/"+this.props.data.id,
      data: {api_token: window.api_token,
        role_is_planner: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_planner]:checked').val(),
        role_is_financial: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_financial]:checked').val(),
        role_is_portal_admin: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_portal_admin]:checked').val(),
        role_is_portal_super_admin: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_portal_super_admin]:checked').val(),
        role_is_company_admin: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_company_admin]:checked').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }

  changePortalAccountDriverEmergencyContactInfo() {
    let labelName = (this.props.data.is_subcontractor == 1) ? 'Subcontractor ' : 'Driver';
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-emergency-contact-info/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_emergency_contact_name: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_emergency_contact_name]').val(),
        driver_emergency_contact_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_emergency_contact_number]').val()
      },
      cache: false,
      method: 'post',
      dataType: "text/json",
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html(labelName+' Info Edited.');
          $('#infomodal .modal-body').html(labelName+' emergency contact info updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the emergency contact details for this '+labelName);
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverContactNumber() {
    let labelName = (this.props.data.is_subcontractor == 1) ? 'Subcontractor ' : 'Driver';
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-contact-number/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_contact_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_phone_number]').val(),
      },
      cache: false,
      method: 'post',
      dataType: "text/json",
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html(labelName+' Info Edited.');
          $('#infomodal .modal-body').html(labelName+' contact number updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem changing the contact number for this '+labelName);
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverEquipmentKitSettings() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-equipment-kit-settings/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_has_got_tablet: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_tablet]:checked').val(),
        driver_has_got_uniform: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_uniform]:checked').val(),
        driver_has_got_id_card: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_id_card]:checked').val(),
        driver_has_got_breakdown_cover: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_breakdown_cover]:checked').val()
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver equipment/kit info updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the equipment/kit information for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountSubcontractorSettings() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-subcontractor-account-info/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        subcontractor_po_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=subcontractor_po_number]:checked').val(),
        subcontractor_access_to_g4: $('#portal-account-full-details-' + this.props.data.id + ' [name=subcontractor_access_to_g4]:checked').val(),
        payment_terms: $('#portal-account-full-details-' + this.props.data.id + ' [name=payment_terms]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Subcontractor Info Edited.');
          $('#infomodal .modal-body').html('Subcontractor info updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the information for this subcontractor.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverHomeAddress() {
    let labelName = (this.props.data.is_subcontractor == 1) ? 'Subcontractor ' : 'Driver';
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-home-address/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_home_address_house_number_or_name: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_house_number_or_name]').val(),
        driver_home_address_address_line_1: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_address_line_1]').val(),
        driver_home_address_address_line_2: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_address_line_2]').val(),
        driver_home_address_address_line_3: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_address_line_3]').val(),
        driver_home_address_town_city: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_town_city]').val(),
        driver_home_address_county_area: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_county_area]').val(),
        driver_home_address_country: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_country]').val(),
        driver_home_address_postcode: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_postcode]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html(labelName+' Info Edited.');
          $('#infomodal .modal-body').html(labelName+' home address updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the equipment/kit information for this '+labelName);
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverPointsOnLicense() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-points-on-license/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_points_on_license: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_points_on_license]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver points on license updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the points on license for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverTradePlateNumber() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-trade-plate-number/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_trade_plate_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_trade_plate_number]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver trade plate rental number updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the trade plate rental number for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverFuelCardNumber() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-fuel-account-number/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        fuel_card_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_fuel_card_number]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver fuel card number updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error updating driver fuel card number');
          $('#infomodal .modal-body').html($.parseHTML(response.responseText.replace(/\"/g, "")));
          $('#infomodal').modal();
        }
      }
    });
  }
  changePortalAccountDriverPriceOption() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-price-option/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_price_option: this.state.driverPriceOption,
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Price Option Saved.');
          $('#infomodal .modal-body').html('Driver price option updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the price for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }
  renderPortalAccountNotifications() {
    let AccountNotifications = [];
    if (this.state.account_notifications_data.length > 0) {
      let jobId = this.props.data.id;
      this.state.account_notifications_data.forEach(function(i) {
        AccountNotifications.push(
          <div key={"job-"+jobId+"-notification-"+i.id}>
            <div className="profile-container">
              <span className="small sidebar-time">{i.sidebar_time}</span>
              <img src={"/user-images/"+i.user_id} width="50" height="50" />
              <span>
              <a href={"/portal-admin/users/view/"+i.user_id}>
                {i.user_name}
              </a> from <a href={"/portal-admin/companies/"+i.user_company_short_name}>
                {i.user_company_short_name}
              </a>
            </span>
            { (i.history && i.history.length > 0) ? <JobFullDetailsJobNotificationsDetails data={i.history}/> : '' }
            </div>
            <div dangerouslySetInnerHTML={{__html: i.message}} className="text-right"></div>
            <hr />
          </div>);
      });
    }

    return (
      <div className="jobs-table-job-notifications-container">{AccountNotifications}</div>
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.email !== nextProps.data.email) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=new_email]').value = (nextProps.data.email);
    }

    if (this.props.data.utr_numer !== nextProps.data.utr_numer) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=utr_numer]').value = (nextProps.data.utr_numer);
    }

    if (this.props.data.first_name !== nextProps.data.first_name) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=first_name]').value = (nextProps.data.first_name);
    }

    if (this.props.data.last_name !== nextProps.data.last_name) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=last_name]').value = (nextProps.data.last_name);
    }

    if (this.props.data.last_name !== nextProps.data.last_name) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=last_name]').value = (nextProps.data.last_name);
    }

    if (this.props.data.driver_id !== null) {
      if (this.props.data.is_subcontractor == 0) {
        document.querySelector("#portal-account-full-details-" + this.props.data.id +
          ' input[name=driver_emergency_contact_name]').value = (
          nextProps.data.driver.emergency_contact
        );
      }
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_emergency_contact_number]').value =
        (nextProps.data.driver.emergency_contact_number
        );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_phone_number]').value = (
        nextProps.data.driver.contact_number
      );
      if (this.props.data.is_subcontractor == 0) {
        document.querySelector("#portal-account-full-details-" + this.props.data.id +
          ' input[name=driver_trade_plate_number]').value = (
          nextProps.data.driver.trade_plate_number
        );
      }
      if (this.props.data.is_subcontractor == 0) {
        document.querySelector("#portal-account-full-details-" + this.props.data.id +
          ' input[name=driver_points_on_license]').value = (
          nextProps.data.driver.points_on_license
        );
      }
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_house_number_or_name]').value = (
        nextProps.data.driver.home_address.house_number_or_name
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_address_line_1]').value = (
        nextProps.data.driver.home_address.address_line_1
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_address_line_2]').value = (
        nextProps.data.driver.home_address.address_line_2
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_address_line_3]').value = (
        nextProps.data.driver.home_address.address_line_3
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_town_city]').value = (
        nextProps.data.driver.home_address.town_city
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_county_area]').value = (
        nextProps.data.driver.home_address.county_area
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_country]').value = (
        nextProps.data.driver.home_address.country
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_postcode]').value = (
        nextProps.data.driver.home_address.postcode
      );
    }
  }
  handleDriverPriceOption(e){
    if(e.currentTarget.value == 'other'){
      this.setState({isOtherDriverPrice:true,driverPriceOption:''});
    }else{
      this.setState({driverPriceOption:e.currentTarget.value,isOtherDriverPrice:false});
    }
  }
  handleDriverPriceOptionText(e){
    this.setState({driverPriceOption:e.currentTarget.value});
  }
  render() {
    let roles = this.props.data.roles,
        isRolePortalSuperAdmin = roles.find(o => o.name === 'portal_super_admin'),
        isRoleSystemAdmin = roles.find(o => o.name === 'portal_admin'),
        isRoleFinancial = roles.find(o => o.name === 'financial'),
        isRolePlanner = roles.find(o => o.name === 'planner'),
        isRoleCompanyAdmin = roles.find(o => o.name === 'company_admin'),
        hasDriverGotTheirUniform = 0,
        subcontractor_po_number = 0,
        hasDriverGotTheirTablet = 0,
        subcontractor_access_to_g4 = 0,
        hasDriverGotTheirIdCard = 0,
        hasDriverGotBreakdownCover = 0,
        driverPointsOnLicense = 0,
        driverEmergencyContactName = '',
        driverEmergencyContactNumber = '',
        driverPhoneNumber = '',
        driverHomeAddressHouseNumberOrName = '',
        driverHomeAddressAddressLine1 = '',
        driverHomeAddressAddressLine2 = '',
        driverHomeAddressAddressLine3 = '',
        driverHomeAddressTownCity = '',
        driverHomeAddressCountyArea = '',
        driverHomeAddressCountry = '',
        driverHomeAddressPostcode = '';
    if (this.props.data.driver_id !== null && this.props.data.driver) {
      hasDriverGotTheirUniform = this.props.data.driver.got_uniform;
      subcontractor_po_number = this.props.data.driver.subcontractor_po_number;
      subcontractor_access_to_g4 = this.props.data.driver.subcontractor_access_to_g4;
      hasDriverGotTheirTablet = this.props.data.driver.got_tablet;
      hasDriverGotTheirIdCard = this.props.data.driver.got_id_card;
      hasDriverGotBreakdownCover = this.props.data.driver.got_breakdown_cover;
      driverPointsOnLicense = this.props.data.driver.points_on_license;

      driverEmergencyContactName = this.props.data.driver.emergency_contact;
      driverEmergencyContactNumber = this.props.data.driver.emergency_contact_number;

      driverPhoneNumber = this.props.data.driver.contact_number;

      driverHomeAddressHouseNumberOrName = this.props.data.driver.home_address.house_number_or_name;
      driverHomeAddressAddressLine1 = this.props.data.driver.home_address.address_line_1;
      driverHomeAddressAddressLine2 = this.props.data.driver.home_address.address_line_2;
      driverHomeAddressAddressLine3 = this.props.data.driver.home_address.address_line_3;
      driverHomeAddressTownCity = this.props.data.driver.home_address.town_city;
      driverHomeAddressCountyArea = this.props.data.driver.home_address.county_area;
      driverHomeAddressCountry = this.props.data.driver.home_address.country;
      driverHomeAddressPostcode = this.props.data.driver.home_address.postcode;
    }

    return (
      <div
        className="portal-admin-table-row portal-account-full-details"
        id={"portal-account-full-details-"+this.props.data.id}
        key={"portal-account-full-details-"+this.props.data.id}
      >
        <div className="row">
          <div className="col-md-3">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Permissions and roles</h3>
              <div>
                <h5>Roles</h5>
              </div>
              <div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Company Admin?
                    <input type="checkbox" name="role_is_company_admin"
                           defaultValue="true"
                           defaultChecked={isRoleCompanyAdmin}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Planner?
                    <input type="checkbox" name="role_is_planner"
                           defaultValue="true"
                           defaultChecked={isRolePlanner}  />


                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Financial?
                    <input type="checkbox" name="role_is_financial"
                           defaultValue="true"
                           defaultChecked={isRoleFinancial}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Portal Admin?
                    <input type="checkbox" name="role_is_portal_admin"
                           defaultValue="true"
                           defaultChecked={isRoleSystemAdmin}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Portal Super Admin?
                    <input type="checkbox" name="role_is_portal_super_admin"
                           defaultValue="true"
                           defaultChecked={isRolePortalSuperAdmin}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <p className="text-center">
                  <button className="btn btn-success" onClick={() => {
                    this.changePortalAccountRoles(this.props.data.id)}}>
                    <i className="fa fa-save"></i> Save Role Settings
                  </button>
                </p>
              </div>
              <PortalCompanyPermission data={this.props.data}></PortalCompanyPermission>
            </div>
            {this.props.data.driver_id != null ?
              <div
                className="portal-admin-table-full-details-column-container
                 drivers-details">
                  {(this.props.data.is_subcontractor == 0) ?
                      <h3>Driver's Details</h3>
                  : <h3>Subcontractor's Details</h3>
                  }

              {(this.props.data.is_subcontractor == 0) ? 
                <div>
                  <h5>Points on {this.props.data.first_name}'s License</h5>
                </div>
              : null}
              {(this.props.data.is_subcontractor == 0) ? 
                <div className="text-center">
                  <p>
                    <input
                      type="text"
                      name="driver_points_on_license"
                      className="form-control form-control-lg text-center"
                      maxLength="2"
                      defaultValue={driverPointsOnLicense}
                    />
                  </p>
                  <p className="text-center">
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        this.changePortalAccountDriverPointsOnLicense(
                          this.props.data.id
                        )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes to Points on License
                    </button>
                  </p>
                </div>
            : null}

                <div>
                  <h5>Emergency Contact</h5>
                </div>


                  <div>
                  {(this.props.data.is_subcontractor == 0) ? 
                  <p>
                    <label>Name:&nbsp;</label>
                    <input type="text"
                           name="driver_emergency_contact_name"
                           className="form-control form-control-lg"
                           defaultValue={driverEmergencyContactName}
                    />
                  </p>
                : null}
                  <p>
                    <label>Number:&nbsp;</label>
                    <input type="text"
                           className="form-control form-control-lg"
                           name="driver_emergency_contact_number"
                           defaultValue={driverEmergencyContactNumber}
                    />
                  </p>

                  <p className="text-center">
                    <button
                      className="btn btn-lg btn-success"
                      onClick={() => {
                        this.changePortalAccountDriverEmergencyContactInfo(
                          this.props.data.id
                        )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes to Emergency Contact
                    </button>
                  </p>
                  </div>


                <div>
                  <h5><i className="fa fa-phone"> </i> Contact Number</h5>
                </div>
                <div className="text-left">
                  <div>
                    <label>
                      {this.props.data.first_name}'s phone number:&nbsp;
                    </label>

                    <input
                      type="text" name="driver_phone_number"
                      defaultValue={driverPhoneNumber}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <br />
                  <p className="text-center">
                    <button className="btn btn-lg btn-success" onClick={() => {
                      this.changePortalAccountDriverContactNumber(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes<br /> to Contact Number
                    </button>
                  </p>
                </div>

                <div>
                {(this.props.data.is_subcontractor == 0) ? 
                  <h5><i className="fa fa-home"> </i> Driver Home Address</h5>
                  : 
                  <h5><i className="fa fa-home"> </i> Subcontractor Home Address</h5>
                }
                </div>
                <div className="text-left">
                  <div>
                    <p>
                      {this.props.data.first_name}'s home address:
                    </p>

                    <p>
                      <strong>House Number or Name:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_house_number_or_name"
                        defaultValue={driverHomeAddressHouseNumberOrName}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Address Line 1:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_address_line_1"
                        defaultValue={driverHomeAddressAddressLine1}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Address Line 2:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_address_line_2"
                        defaultValue={driverHomeAddressAddressLine2}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Address Line 3:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_address_line_3"
                        defaultValue={driverHomeAddressAddressLine3}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Town/City:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_town_city"
                        defaultValue={driverHomeAddressTownCity}
                        className="form-control form-control-lg"
                      />
                    </p>


                    <p>
                      <strong>County/Area:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_county_area"
                        defaultValue={driverHomeAddressCountyArea}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Country:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_country"
                        defaultValue={driverHomeAddressCountry}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Postcode:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_postcode"
                        defaultValue={driverHomeAddressPostcode}
                        className="form-control form-control-lg"
                      />
                    </p>


                  </div>

                  <p className="text-center">
                  {(this.props.data.is_subcontractor == 0) ? 
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverHomeAddress(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes to Driver's Home Address
                    </button>
                    :
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverHomeAddress(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes to Subcontractor's Home Address
                    </button>
                    }
                  </p>
                </div>

                {(this.props.data.is_subcontractor == 0) ? 
                <div>
                  <h5>Equipment/Kit</h5>
                </div>
                : null }
                {(this.props.data.is_subcontractor == 0) ? 
                <div>
                  <div className="checkbox">
                    <label> Has this driver got their uniform?
                      <input type="checkbox" name="driver_has_got_uniform"
                             defaultValue="true"
                             defaultChecked={hasDriverGotTheirUniform}  />

                      <span className="cr">
                      <i className="cr-icon fa fa-check"> </i>
                    </span>
                    </label>
                  </div>

                  <div className="checkbox">
                    <label> Has this driver got their tablet?
                      <input type="checkbox" name="driver_has_got_tablet"
                             defaultValue="true"
                             defaultChecked={hasDriverGotTheirTablet}  />
                      <span className="cr">
                      <i className="cr-icon fa fa-check"> </i>
                    </span>
                    </label>
                  </div>

                  <div className="checkbox">
                    <label> Has this driver got their ID Card?
                      <input type="checkbox" name="driver_has_got_id_card"
                             defaultValue="true"
                             defaultChecked={hasDriverGotTheirIdCard}  />
                      <span className="cr"><i className="cr-icon fa fa-check"> </i></span>
                    </label>
                  </div>

                  <div className="checkbox">
                    <label> Has this driver got breakdown cover?
                      <input type="checkbox" name="driver_has_got_breakdown_cover"
                             defaultValue="true"
                             defaultChecked={hasDriverGotBreakdownCover}  />
                      <span className="cr"><i className="cr-icon fa fa-check"> </i></span>
                    </label>
                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverEquipmentKitSettings(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i> Save Changes to Equipment Info
                    </button>
                  </p>

                </div>
              : null }

              {(this.props.data.is_subcontractor == 1) ? 
                <div>
                  <div className="checkbox">
                    <label> PO Number required?
                      <input type="checkbox" name="subcontractor_po_number"
                             defaultValue="true"
                             defaultChecked={subcontractor_po_number}  />

                      <span className="cr">
                      <i className="cr-icon fa fa-check"> </i>
                    </span>
                    </label>
                  </div>

                  <div className="checkbox">
                    <label> Access to G4 portal?
                      <input type="checkbox" name="subcontractor_access_to_g4"
                             defaultValue="true"
                             defaultChecked={subcontractor_access_to_g4}  />
                      <span className="cr">
                      <i className="cr-icon fa fa-check"> </i>
                    </span>
                    </label>
                  </div>

                  <div>
                    <label>Payment terms</label>
                    <br />
                    <input
                      type="text"
                      name="payment_terms"
                      defaultValue={this.props.data.driver.payment_terms}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <br />
                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountSubcontractorSettings(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i> -- Save Changes --
                    </button>
                  </p>

                </div>
              : null }

              {(this.props.data.is_subcontractor == 0) ? 
                <div>
                  <h5>Trade Plate Number</h5>
                </div>
                : null }

                {(this.props.data.is_subcontractor == 0) ? 
                <div className="text-left">
                  <div>
                    <label>
                      {
                        this.props.data.first_name
                      }'s Trade Plate:</label>
                    <br />
                    <input
                      type="text"
                      name="driver_trade_plate_number"
                      defaultValue={this.props.data.driver.trade_plate_number}
                      className="form-control form-control-lg"
                    />
                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverTradePlateNumber(
                        this.props.data.id)
                    }}>
                      <i className="fa fa-save"> </i>
                      Save Changes to Trade Plate
                    </button>
                  </p>
                </div>
              : null }


                <div className="text-left">
                  <div>
                    <label>
                      {
                        this.props.data.first_name
                      }'s Fuel Card Number:</label>
                    <br />
                    <input
                      type="text"
                      name="driver_fuel_card_number"
                      defaultValue={this.props.data.driver.fuel_card_number}
                      className="form-control form-control-lg"
                    />
                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverFuelCardNumber(
                        this.props.data.id)
                    }}>
                      <i className="fa fa-save"> </i>
                      Save Changes to Fuel Card Number
                    </button>
                  </p>
                </div>

              {(this.props.data.is_subcontractor == 0) ? 
                <div>
                  <h5>Driver Price Options</h5>
                </div>
                : null }

                {(this.props.data.is_subcontractor == 0) ? 
                <div className="text-left job-ref-font20">
                  <div>
                    <label>
                      {
                        this.props.data.first_name
                      }'s Driver Price:</label>
                    <br />
                    <div>
                      {/* <label className="radio-inline">
                        <input type="radio" name="driver_price_radio" value="28" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '28') ? true : false}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 28/20 &nbsp;
                      </label> */}

                      <label className="radio-inline">
                        <input type="radio" name="driver_price_radio" value="30" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '30') ? true : false}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 30/24 &nbsp;
                      </label>

                      <label className="radio-inline">
                        <input type="radio" name="driver_price_radio" value="30/30" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '30/30') ? true : false}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 30/30 &nbsp;
                      </label>

                      <label className="radio-inline">
                        <input type="radio" name="driver_price_radio" value="30/34" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '30/34') ? true : false}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 30/34 &nbsp;
                      </label>
                      {/* <label className="radio-inline">
                        <input type="radio" name="driver_price_radio"  value="other" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '20' || this.props.data.driver.driver_price_option == '25' ) ? false : true}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; Other
                      </label> */}
                    </div>
                    {/* {(this.state.isOtherDriverPrice) ? 
                      <div>
                        <input type="text" name="driver_price_radio_text" 
                        className="form-control form-control-lg" 
                        placeholder="Enter amount"
                        value={this.state.driverPriceOption}
                        onChange={(e)=>this.handleDriverPriceOptionText(e)}/>
                      </div>
                    : null} */}
                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverPriceOption(
                        this.props.data.id)
                    }}>
                      <i className="fa fa-save"> </i>&nbsp; Save Changes to Driver Price
                    </button>
                  </p>
                </div>
                : null }
              </div>
              : null
            }
          </div>

          <div className="col-md-6">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Portal Activity</h3>
              <div>{
                this.renderPortalAccountNotifications()
              }</div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Admin Controls</h3>

              <div>
                <p>
                  <strong>Holiday Status</strong>
                </p>
                <p>
                  Current Status: '{
                  this.props.data.account_holiday_status
                }'<br />
                </p>
                <div className="text-right">
                  {this.props.data.account_holiday_status === 'on_holiday' ?
                    <button onClick={() => {
                      this.setPortalAccountNotOnHoliday(this.props.data.id)}}
                            className="btn btn-danger">
                      <i className="fa fa-pause"> </i> On Holiday
                    </button>
                    :
                    <button onClick={() => {
                      this.setPortalAccountOnHoliday(this.props.data.id)}}
                            className="btn btn-success">
                      <i className="fa fa-play"></i> Not on Holiday
                    </button>
                  }
                </div>
              </div>
              <div>
                <p>
                  <strong>Lock Account</strong>
                </p>
                <p>
                  Current Status: '{this.props.data.account_status}'<br />
                </p>
                <div className="text-right">
                  {this.props.data.account_status === 'locked' ?
                    <button onClick={() => {
                      this.unlockPortalAccount(this.props.data.id)}}
                            className="btn btn-danger">
                      <i className="fa fa-lock"></i> Account locked
                    </button>
                    :
                    <button onClick={() => {
                      this.lockPortalAccount(this.props.data.id)}}
                            className="btn btn-success">
                      <i className="fa fa-unlock"></i> Active
                    </button>
                  }
                </div>
              </div>
              
              {(this.props.data.driver_id !== null && this.props.data.driver && this.props.data.is_subcontractor == 0) ?
              <div>
                <p>
                  <strong>Is Sick ?</strong>
                </p>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} Driver Sick ?
                    <input type="checkbox" name="is_driver_archieved"
                           defaultValue={this.props.data.is_driver_sick}
                           defaultChecked={this.props.data.is_driver_sick}
                           onChange={(e) => this.handleSickChecked(e) }  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                  <br/>
                </div>
              </div>
              : ''}

              {(this.props.data.driver_id !== null && this.props.data.driver && this.props.data.is_subcontractor == 0) ?
              <div>
                <p>
              <strong>Archive Driver</strong>
                </p>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} Driver Archived?
                    <input type="checkbox" name="is_driver_archieved"
                           defaultValue={this.props.data.is_driver_archieved}
                           defaultChecked={this.props.data.is_driver_archieved}
                           onChange={(e) => this.handleChecked(e) }  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
              </div>
              : 
              <div>
                <p>
              <strong>Archive Customer</strong>
                </p>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} Customer Archived?
                    <input type="checkbox" name="is_customer_archived"
                           defaultValue={this.props.data.is_customer_archived}
                           defaultChecked={this.props.data.is_customer_archived}
                           onChange={(e) => this.handleCheckedcustomer(e) }  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
              </div>
              }

            {(this.props.data.driver_id !== null && this.props.data.driver && this.props.data.is_subcontractor == 0) ?
              <div className="form-group unit-term-group">
                  <h5>Is {this.props.data.first_name} a smoker ?</h5>
                  <div className="btn-group btn-group-toggle" id="is-driver-smoker-radio-container">
                    <label className={(this.props.data.is_driver_smoker) ? "btn btn-secondary focus active" : "btn btn-secondary"} id="is-driver-smoker-yes">
                          <input className={"form-control form-control-lg"}
                          defaultChecked={(this.props.data.is_driver_smoker) ? true : false}
                          name="is_driver_smoker"
                          type="radio"
                          onChange={(e)=>this.handleDriverIsSmoker(e)}
                          value="1" /> YES
                      </label>

                    <label className={(!this.props.data.is_driver_smoker) ? "btn btn-secondary focus active" : "btn btn-secondary"} id="is-driver-smoker-no">
                          <input className={"form-control form-control-lg"}
                            name="is_driver_smoker"
                            onChange={(e)=>this.handleDriverIsSmoker(e)}
                            defaultChecked={(!this.props.data.is_driver_smoker) ? true : false}
                            type="radio" value="0" /> NO
                    </label>
                  </div>    
                </div>
              : ''}

            {(this.props.data.driver_id !== null && this.props.data.driver && this.props.data.is_subcontractor == 0) ?
              <div className="form-group unit-term-group">
                  <h5>Is {this.props.data.first_name} paid expenses ?</h5>
                  <div className="btn-group btn-group-toggle" id="is-driver-get-paid-expenses-radio-container">
                    <label className={(this.props.data.is_driver_get_paid_expenses) ? "btn btn-secondary focus active" : "btn btn-secondary"} id="is-driver-get-paid-expenses-yes">
                          <input className={"form-control form-control-lg"}
                          defaultChecked={(this.props.data.is_driver_get_paid_expenses) ? true : false}
                          name="is_driver_get_paid_expenses"
                          type="radio"
                          onChange={(e)=>this.handleDriverIsGetPaidExpenses(e)}
                          value="1" /> YES
                      </label>

                    <label className={(!this.props.data.is_driver_get_paid_expenses) ? "btn btn-secondary focus active" : "btn btn-secondary"} id="is-driver-get-paid-expenses-no">
                          <input className={"form-control form-control-lg"}
                            name="is_driver_get_paid_expenses"
                            onChange={(e)=>this.handleDriverIsGetPaidExpenses(e)}
                            defaultChecked={(!this.props.data.is_driver_get_paid_expenses) ? true : false}
                            type="radio" value="0" /> NO
                    </label>
                  </div>    
                </div>
              : ''}
              
              <div>
                <p><strong>Change Name</strong></p>
                <div className="input-group m-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="user-first-name">First Name: </span>
                  </div>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    aria-label="First Name"
                    aria-describedby="user-first-name"
                    defaultValue={this.props.data.first_name} />
                </div>
                <div className="input-group m-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="user-last-name">Last Name: </span>
                  </div>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    aria-label="Last Name"
                    aria-describedby="user-last-name"
                    defaultValue={this.props.data.last_name} />
                </div>
                <p className="text-right">
                  <button onClick={() => {
                    this.changePortalAccountName(
                      this.props.data.id
                    )}}
                          className="btn btn-primary">
                    Update Name for this user
                  </button>
                </p>
              </div>
              <div>
                <p>
                  <strong>Change Email Address And Password</strong>
                </p>
                <p>
                  <input
                    type="text"
                    name="new_email"
                    className="form-control"
                    defaultValue={this.props.data.email} />
                </p>
                <p>
                  <input
                    type="text"
                    className="form-control"
                    name="new_password"
                    placeholder="New Password Here" />
                </p>
                <p className="text-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      this.changePortalAccountEmailAddress(
                        this.props.data.id
                      )}}>
                    Change Email Address And Password
                  </button>
                </p>
              </div>

              <div>
                <div className="sectionStaffUsers">
                </div>
                  <p className="text-right d-none portalAccountButton mt-4"> <button className="btn btn-primary" onClick={()=>{this.changePortalAccountStaffEmailAddress()}}> Change Email Address And Password </button> </p>
              </div>
              
              <div className="multipleUsers">
                <div className="sectionMultipleUsers">
                  <p><strong>Staff List - Add New Email Address And Password</strong> </p>
                </div>
                
                <div className="row mt-4">
                  <div className="col-md-4">
                    <p className="text-right">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          this.addNewPortalUser(
                            this.props.data.id
                          )}}>
                        Add
                      </button>
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p className="text-right d-none removePortalUserClone">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          this.removePortalUser(
                            this.props.data.id
                          )}}>
                        Remove
                      </button>
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p className="text-right d-none savePortalUserClone">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          this.saveMultiplePortalUsers(
                            this.props.data.id
                          )}}>
                        Save
                      </button>
                    </p>
                  </div>
                </div>
              </div>          

              {(this.props.data.driver_id !== null && this.props.data.driver && this.props.data.is_subcontractor == 0) ?
              <div>
                <p>
                  <strong>UTR Number</strong>
                </p>
                <p>
                  <input
                    type="text"
                    name="utr_number"
                    className="form-control"
                    defaultValue={this.props.data.utr_number} />
                </p>
                <p className="text-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      this.changePortalAccountUTRNumber(
                        this.props.data.id
                      )}}>
                    Change UTR Number
                  </button>
                </p>
              </div>
              : ''}
              {/* <div>
                <p><strong>Change Password</strong></p>
                <p>
                  <input
                    type="text"
                    className="form-control"
                    name="new_password"
                    placeholder="New Password Here" />
                </p>
                <p className="text-right">
                  <button onClick={() => {
                    this.changePortalAccountPassword(
                      this.props.data.id
                    )}}
                          className="btn btn-primary">
                    Update Password For this User
                  </button>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}